module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Success":"Les adresses ont été ajoutées au compte avec succès."},"fr":{"Success":"Les adresses ont été ajoutées au compte avec succès."}}')
  delete Component.options._Ctor
}
